import React from "react";
import { NavLink } from "react-router-dom";

import { isMenuActive } from "../../../../utils/adminNavigation";
import { getModuleMeta } from "../data/adminShellConfig";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SidebarLink({
  item,
  pathname,
  isCollapsed,
  mobile = false,
  onNavigate,
}) {
  const active = isMenuActive(pathname, item);
  const meta = getModuleMeta(item.moduleKey);
  const Icon = meta.icon;

  const compact = isCollapsed && !mobile;

  return (
    <NavLink
      to={item.path}
      onClick={onNavigate}
      title={item.title}
      className={cn(
        "group relative mx-2 flex overflow-hidden rounded-[1.35rem] px-3 py-2.5 text-sm transition-all duration-200",
        compact ? "justify-center" : "items-center gap-3",
        active
          ? `bg-gradient-to-r ${meta.gradient} text-white shadow-lg shadow-sky-500/15`
          : "text-slate-600 hover:bg-white hover:text-slate-950 hover:shadow-sm dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white",
      )}
    >
      {active ? (
        <span className="absolute inset-y-2 left-0 w-1 rounded-r-full bg-white/80" />
      ) : null}

      <span
        className={cn(
          "relative flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl text-lg transition",
          active
            ? "bg-white/15 text-white"
            : `${meta.softBg} ${meta.softText} group-hover:scale-105`,
        )}
      >
        <Icon />
      </span>

      {!compact ? (
        <span className="relative min-w-0 flex-1">
          <span
            className={cn(
              "block truncate font-bold",
              active ? "text-white" : "text-inherit",
            )}
          >
            {item.title}
          </span>

          <span
            className={cn(
              "mt-0.5 hidden truncate text-xs lg:block",
              active
                ? "text-white/80"
                : "text-slate-400 dark:text-slate-500",
            )}
          >
            {meta.description}
          </span>
        </span>
      ) : null}
    </NavLink>
  );
}